import { useState } from 'react';

import { useParams } from 'react-router-dom';

import { Stack } from '@mui/material';
import useOrders from 'api/useOrders';

import AcSeparator from 'components/AcSeparator/AcSeparator';

import AddNewEvidence from './AddNewEvidence';
import DisputeEvidenceTable from './DisputeEvidenceTable';

const DisputeEvidence = (orderParams: any) => {
  const { orderId } = useParams();

  const { getOrderDetails: order } = useOrders(orderId, undefined, undefined, {
    selectedProjects: orderParams.publisherId
  });

  return (
    <>
      <AcSeparator marginTop={0} marginBottom={'16px'} />
      <Stack spacing={2} pt={2}>
        <h2 className="order__section-title">Dispute Evidences</h2>
        <AddNewEvidence orderParams={orderParams} />
      </Stack>
      <DisputeEvidenceTable order={order} />
    </>
  );
};

export default DisputeEvidence;
